import React, { useContext, useState, useEffect, useRef } from "react";
import { Tabs, Tab, Form, Dropdown, Button, Row, Col } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import swal from "sweetalert";
import { BASE_URL_API, BASE_URL_API_TRANXT_API, BASE_URL_APISERVICES } from "../../utils/Constants";
import { GlobalContext } from "../../Context/GlobalState";
import { useHistory } from "react-router";
import { basicAuth } from "../../config";
import {
  createHash,
  generateHashKey2,
  getLatLong,
} from "./../../utils/utilFuctions";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";

const userTypes = [
  { label: "Master Distributor", value: "4" },
  { label: "Distributor", value: "3" },
  { label: "Retailer", value: "2" },
  { label: "API Partner", value: "5" },
];

const tariff = [{ label: "Bumppy", value: "3" }];

const AepsOnboarding = ({ agentId }) => {
  const initialState = {
    Latitude: "",
    Longitude: "",
    Latitude1: "",
    Longitude1: "",
  };

  const [state, setState] = useState(initialState);
  const [userRoles, setUserRoles] = useState([]);
  const [parentList, setParentList] = useState([]);

  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const validateForm = () => {
    if (state.Latitude == "" || state.Latitude == "") {
      swal("Invalid", "Please Fill Mandatory Fields", "error");
      return;
    }
    updateLatLong();
  };
  const validateForm1 = () => {
    if (state.Latitude1 == "" || state.Latitude1 == "") {
      swal("Invalid", "Please Fill Mandatory Fields", "error");
      return;
    }
    updateAeps2LatLong();
  };

  const clearForm = () => {
    setState(initialState);
  };

  const updateLatLong = async () => {
    try {
      setTransactionLoaderState(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userid: agentId,
        latitude: state.Latitude,
        longitude: state.Longitude,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `https://bumppy.com/apibumppypay/v1/web/fingpay/updateLatLong.php`,
        requestOptions
      );

      const data = await res.json();
      if (data.status == "00") {
        swal("Success", data.message, "success");
        clearForm();
      } else {
        swal("Failed", data.message, "error");
      }
      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
      swal("Latitude Longitude Updated Failed", "Error From Server", "error");
    }
  };

  const getAeps2LatLong = async () => {
    try {
      setTransactionLoaderState(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userid: agentId,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.getAeps2LatLong}`,
        requestOptions
      );

      const data = await res.json();
      if (data.responseCode === "00") {
        setState({
          Latitude1: data.data.latitude,
          Longitude1: data.data.longitude,
        });
      } else {
        swal("Failed", data.message, "error");
      }
    } catch (error) {
      console.log("error", error);
      swal("Latitude Longitude Update Failed", "Error From Server", "error");
    } finally {
      setTransactionLoaderState(false);
    }
  };

  const updateAeps2LatLong = async () => {
    try {
      setTransactionLoaderState(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userid: agentId,
        latitude: state.Latitude1,
        longitude: state.Longitude1,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.updateAeps2LatLong}`,
        requestOptions
      );

      const data = await res.json();
      if (data.responseCode == "00") {
        swal("Success", data.responseMessage, "success");
        clearForm();
      } else {
        swal("Failed", data.responseMessage, "error");
      }
      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
      swal("Latitude Longitude Updated Failed", "Error From Server", "error");
    }
  };

  // useEffect(() => {
  //   getAeps2LatLong();
  // }, []);
  return (
    <div style={{ padding: "1rem" }} className="bg-light">
      <div
        style={{ borderRadius: "8px" }}
        className="card m-0 p-0 mt-4 mr-2 ml-2"
      >
        {/* <div className="card-body m-0 p-1 px-2">
 <div>

 <div className="p-2 pl-1"
 style={{
 "fontFamily":"Poppins","fontSize":"32px","fontWeight":"600","lineHeight":"48px","letterSpacing":"0em","textAlign":"left"
 ,padding: "0px",
 background: "#FFFFFF",
 color: "#4267B2",
 fontWeight: "bolder",
 fontfamily: "Poppins !impotent",
 fontSize:"28px",

 

 }}
 >
 Aeps ON-Boarding
 </div>

 <div>
 
 <div className="row col-12 justify-content-start m-0 pl-10 py-0 pb-1">
 <div className="col-5 pr-3 m-0 p-0 ">
 <Form.Group>
 <Form.Label className="text-dark">
 <span style={{ color: "red" }}>*</span>
 {`Latitude`}
 </Form.Label>
 <Form.Control
 type="text"
 className="form-control rounded-lg"
 aria-label="Notes"
 aria-describedby="basic-addon1"
 placeholder="Enter Latitude"
 value={state.Latitude}
 onChange={(e) => {
 setState({ ...state, Latitude: e.target.value });
 }}
 style={{ borderRadius: "0px" }}
 />
 </Form.Group>
 </div>

 <div className="col-5 p-0 m-0 pr-3">
 <Form.Group>
 <Form.Label className="text-dark">
 <span style={{ color: "red" }}>*</span>
 {`Longitude `}
 </Form.Label>
 <Form.Control
 type="text"
 className="form-control rounded-lg"
 aria-label="Notes"
 aria-describedby="basic-addon1"
 placeholder="Enter Longitude"
 value={state.Longitude}
 onChange={(e) => {
 setState({ ...state, Longitude: e.target.value });
 }}
 style={{ borderRadius: "0px" }}
 />
 </Form.Group>
 </div>
 
 </div>

 <div className="row col-12 pl-10 py-0 m-0 pb-3">
 
 <div className="col-5 p-0 mt-4 pr-3 ">
 <Button
 className="rounded-10 btn-block "
 variant="primary"
 onClick={validateForm}
 >
 {" "}
 Submit
 </Button>
 
 </div>
 <div className="col-5 p-0 m-0 mt-4 pr-3">
 <Button
 className="rounded-10 btn-block border border-primary"
 variant="white"
 onClick={clearForm}
 >
 {" "}
 Clear
 </Button>
 </div>
 <div className="col-2"></div>
 </div>
 </div>
 </div>
 </div>

 <div className="card-body m-0 p-1 px-2">
 <div>

 <div className="p-2 pl-1"
 style={{
 "fontFamily":"Poppins","fontSize":"32px","fontWeight":"600","lineHeight":"48px","letterSpacing":"0em","textAlign":"left"
 ,padding: "0px",
 background: "#FFFFFF",
 color: "#4267B2",
 fontWeight: "bolder",
 fontfamily: "Poppins !impotent",
 fontSize:"28px",

 

 }}
 >
 Aeps 2 ON-Boarding
 </div>

 <div>
 
 <div className="row col-12 justify-content-start m-0 pl-10 py-0 pb-1">
 <div className="col-5 pr-3 m-0 p-0 ">
 <Form.Group>
 <Form.Label className="text-dark">
 <span style={{ color: "red" }}>*</span>
 {`Latitude`}
 </Form.Label>
 <Form.Control
 type="text"
 className="form-control rounded-lg"
 aria-label="Notes"
 aria-describedby="basic-addon1"
 placeholder="Enter Latitude"
 value={state.Latitude1}
 onChange={(e) => {
 setState({ ...state, Latitude1: e.target.value });
 }}
 style={{ borderRadius: "0px" }}
 />
 </Form.Group>
 </div>

 <div className="col-5 p-0 m-0 pr-3">
 <Form.Group>
 <Form.Label className="text-dark">
 <span style={{ color: "red" }}>*</span>
 {`Longitude `}
 </Form.Label>
 <Form.Control
 type="text"
 className="form-control rounded-lg"
 aria-label="Notes"
 aria-describedby="basic-addon1"
 placeholder="Enter Longitude"
 value={state.Longitude1}
 onChange={(e) => {
 setState({ ...state, Longitude1: e.target.value });
 }}
 style={{ borderRadius: "0px" }}
 />
 </Form.Group>
 </div>
 
 </div>

 <div className="row col-12 pl-10 py-0 m-0 pb-3">
 
 <div className="col-5 p-0 mt-4 pr-3 ">
 <Button
 className="rounded-10 btn-block "
 variant="primary"
 onClick={validateForm1}
 >
 {" "}
 Submit
 </Button>
 
 </div>
 <div className="col-5 p-0 m-0 mt-4 pr-3">
 <Button
 className="rounded-10 btn-block border border-primary"
 variant="white"
 onClick={clearForm}
 >
 {" "}
 Clear
 </Button>
 </div>
 <div className="col-2"></div>
 </div>
 </div>
 </div>
 </div> */}
        <div className="card-body m-0 p-0">
          <div>
            <div
              style={{ overflowX: "auto", width: "100%" }}
              defaultActiveKey="profile"
              className=" tab-header justify-content-between"
            >
              <div
                className={`tab-item ${activeTab === 0 ? "active" : ""}`}
                onClick={() => handleTabClick(0)}
              >
                On-Boarding
              </div>
              <div
                className={`tab-item ${activeTab === 1 ? "active" : ""}`}
                onClick={() => handleTabClick(1)}
              >
                AEPS
              </div>
              <div
                className={`tab-item ${activeTab === 2 ? "active" : ""}`}
                onClick={() => handleTabClick(2)}
              >
                AEPS 2
              </div>
            </div>
            <div className="tab-content">
              {activeTab === 0 && (
                <div>
                  {" "}
                  <AepsOnboarding2 agentId={agentId} />{" "}
                </div>
              )}
              {activeTab === 1 && (
                <div>
                  <Aeps agentId={agentId} />
                </div>
              )}
              {activeTab === 2 && (
                <div>
                  <Aeps2 agentId={agentId} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const AepsOnboarding2 = ({ agentId }) => {
  const initialState = {
    Latitude: "",
    Longitude: "",
    Latitude1: "",
    Longitude1: "",
  };

  const [state, setState] = useState(initialState);
  const [userRoles, setUserRoles] = useState([]);
  const [parentList, setParentList] = useState([]);

  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const validateForm = () => {
    if (state.Latitude == "" || state.Latitude == "") {
      swal("Invalid", "Please Fill Mandatory Fields", "error");
      return;
    }
    updateLatLong();
  };
  const validateForm1 = () => {
    if (state.Latitude1 == "" || state.Latitude1 == "") {
      swal("Invalid", "Please Fill Mandatory Fields", "error");
      return;
    }
    updateAeps2LatLong();
  };

  const clearForm = () => {
    setState(initialState);
  };

  const updateLatLong = async () => {
    try {
      setTransactionLoaderState(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userid: agentId,
        latitude: state.Latitude,
        longitude: state.Longitude,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `https://bumppy.com/apibumppypay/v1/web/fingpay/updateLatLong.php`,
        requestOptions
      );

      const data = await res.json();
      if (data.status == "00") {
        swal("Success", data.message, "success");
        clearForm();
      } else {
        swal("Failed", data.message, "error");
      }
      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
      swal("Latitude Longitude Updated Failed", "Error From Server", "error");
    }
  };

  const getAeps2LatLong = async () => {
    try {
      setTransactionLoaderState(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userid: agentId,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.getAeps2LatLong}`,
        requestOptions
      );

      const data = await res.json();
      if (data.responseCode === "00") {
        setState({
          Latitude1: data.data.latitude,
          Longitude1: data.data.longitude,
        });
      } else {
        swal("Failed", data.message, "error");
      }
    } catch (error) {
      console.log("error", error);
      swal("Latitude Longitude Update Failed", "Error From Server", "error");
    } finally {
      setTransactionLoaderState(false);
    }
  };

  const updateAeps2LatLong = async () => {
    try {
      setTransactionLoaderState(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userid: agentId,
        latitude: state.Latitude1,
        longitude: state.Longitude1,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.updateAeps2LatLong}`,
        requestOptions
      );

      const data = await res.json();
      if (data.responseCode == "00") {
        swal("Success", data.responseMessage, "success");
        clearForm();
      } else {
        swal("Failed", data.responseMessage, "error");
      }
      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
      swal("Latitude Longitude Updated Failed", "Error From Server", "error");
    }
  };

  useEffect(() => {
    getAeps2LatLong();
  }, []);
  return (
    <div style={{ padding: "1rem" }} className="bg-light">
      <div
        style={{ borderRadius: "8px" }}
        className="card m-0 p-0 mt-4 mr-2 ml-2"
      >
        <div className="card-body m-0 p-1 px-2">
          <div>
            <div
              className="p-2 pl-1"
              style={{
                fontFamily: "Poppins",
                fontSize: "32px",
                fontWeight: "600",
                lineHeight: "48px",
                letterSpacing: "0em",
                textAlign: "left",
                padding: "0px",
                background: "#FFFFFF",
                color: "#4267B2",
                fontWeight: "bolder",
                fontfamily: "Poppins !impotent",
                fontSize: "28px",
              }}
            >
              Aeps ON-Boarding
            </div>

            <div>
              <div className="row col-12 justify-content-start m-0 pl-10 py-0 pb-1">
                <div className="col-5 pr-3 m-0 p-0 ">
                  <Form.Group>
                    <Form.Label className="text-dark">
                      <span style={{ color: "red" }}>*</span>
                      {`Latitude`}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      className="form-control rounded-lg"
                      aria-label="Notes"
                      aria-describedby="basic-addon1"
                      placeholder="Enter Latitude"
                      value={state.Latitude}
                      onChange={(e) => {
                        setState({ ...state, Latitude: e.target.value });
                      }}
                      style={{ borderRadius: "0px" }}
                    />
                  </Form.Group>
                </div>

                <div className="col-5 p-0 m-0 pr-3">
                  <Form.Group>
                    <Form.Label className="text-dark">
                      <span style={{ color: "red" }}>*</span>
                      {`Longitude `}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      className="form-control rounded-lg"
                      aria-label="Notes"
                      aria-describedby="basic-addon1"
                      placeholder="Enter Longitude"
                      value={state.Longitude}
                      onChange={(e) => {
                        setState({ ...state, Longitude: e.target.value });
                      }}
                      style={{ borderRadius: "0px" }}
                    />
                  </Form.Group>
                </div>
              </div>

              <div className="row col-12 pl-10 py-0 m-0 pb-3">
                <div className="col-5 p-0 mt-4 pr-3 ">
                  <Button
                    className="rounded-10 btn-block "
                    variant="primary"
                    onClick={validateForm}
                  >
                    {" "}
                    Submit
                  </Button>
                </div>
                <div className="col-5 p-0 m-0 mt-4 pr-3">
                  <Button
                    className="rounded-10 btn-block border border-primary"
                    variant="white"
                    onClick={clearForm}
                  >
                    {" "}
                    Clear
                  </Button>
                </div>
                <div className="col-2"></div>
              </div>
            </div>
          </div>
        </div>

        <div className="card-body m-0 p-1 px-2">
          <div>
            <div
              className="p-2 pl-1"
              style={{
                fontFamily: "Poppins",
                fontSize: "32px",
                fontWeight: "600",
                lineHeight: "48px",
                letterSpacing: "0em",
                textAlign: "left",
                padding: "0px",
                background: "#FFFFFF",
                color: "#4267B2",
                fontWeight: "bolder",
                fontfamily: "Poppins !impotent",
                fontSize: "28px",
              }}
            >
              Aeps 2 ON-Boarding
            </div>

            <div>
              <div className="row col-12 justify-content-start m-0 pl-10 py-0 pb-1">
                <div className="col-5 pr-3 m-0 p-0 ">
                  <Form.Group>
                    <Form.Label className="text-dark">
                      <span style={{ color: "red" }}>*</span>
                      {`Latitude`}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      className="form-control rounded-lg"
                      aria-label="Notes"
                      aria-describedby="basic-addon1"
                      placeholder="Enter Latitude"
                      value={state.Latitude1}
                      onChange={(e) => {
                        setState({ ...state, Latitude1: e.target.value });
                      }}
                      style={{ borderRadius: "0px" }}
                    />
                  </Form.Group>
                </div>

                <div className="col-5 p-0 m-0 pr-3">
                  <Form.Group>
                    <Form.Label className="text-dark">
                      <span style={{ color: "red" }}>*</span>
                      {`Longitude `}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      className="form-control rounded-lg"
                      aria-label="Notes"
                      aria-describedby="basic-addon1"
                      placeholder="Enter Longitude"
                      value={state.Longitude1}
                      onChange={(e) => {
                        setState({ ...state, Longitude1: e.target.value });
                      }}
                      style={{ borderRadius: "0px" }}
                    />
                  </Form.Group>
                </div>
              </div>

              <div className="row col-12 pl-10 py-0 m-0 pb-3">
                <div className="col-5 p-0 mt-4 pr-3 ">
                  <Button
                    className="rounded-10 btn-block "
                    variant="primary"
                    onClick={validateForm1}
                  >
                    {" "}
                    Submit
                  </Button>
                </div>
                <div className="col-5 p-0 m-0 mt-4 pr-3">
                  <Button
                    className="rounded-10 btn-block border border-primary"
                    variant="white"
                    onClick={clearForm}
                  >
                    {" "}
                    Clear
                  </Button>
                </div>
                <div className="col-2"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Aeps = ({ agentId }) => {
  const initialState = {
    eKYCStatus: "N",
    pipe1_kyc: "N",
  };

  const [state, setState] = useState(initialState);
  const [ekycStatus, setEkycStatus] = useState("N");
  const [twoFactorStatus, setTwoFactoStatus] = useState("N");
  const [userRoles, setUserRoles] = useState([]);
  const [parentList, setParentList] = useState([]);

  const { user, setTransactionLoaderState, Profileinfo } = useContext(GlobalContext);
  const [activeTab, setActiveTab] = useState(0);
  const [credentials, setCredentials] = useState(true);


  const getkycstatus = async () => {
    try {
      setTransactionLoaderState(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userid: agentId,
        step: "2",
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.twoFactorCheck}`,
        requestOptions
      );

      const data = await res.json();
      if (data.status === "0") {
        setState({
          ...state,
          eKYCStatus: data.data.cw_status === "Y" ? "Y" : "N",
        });
        setTwoFactoStatus(data.data ? data.data.cw_status === "Y" ? "Y" : "N" : "N");
      }
    } catch (error) {
      console.log("error", error);
      swal("Failed", JSON.stringify(error), "error");
    } finally {
      setTransactionLoaderState(false);
    }
  };
  // const twoFactorCheck = async () => {
  //   try {
  //     const raw = "";
  //     const hash_key = await generateHashKey2(user.ReferId);
  //     var myHeaders = new Headers();
  //     myHeaders.append("HASH_KEY", hash_key);
  //     myHeaders.append("Content-Type", "application/json");
  //     var requestOptions = {
  //       method: "POST",
  //       headers: myHeaders,
  //       body: raw,
  //       redirect: "follow",
  //     };

  //     const res = await fetch(
  //       `https://apitranxt.bumppypay.com//recApiFinal/apiget.aspx?method=getkycstatus&userid=${agentId}`,
  //       requestOptions
  //     );

  //     const data = await res.json();
  //     setState({
  //       ...state,
  //       pipe1_kyc: data.f_ekyc_status == "Y" ? "Y" : "N",
  //     });

  //     setEkycStatus(data.f_ekyc_status == "Y" ? "Y" : "N");
  //   } catch (error) {
  //     console.log("error", error);
  //   }
  // };

  const twoFactorCheck = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      
      const raw = JSON.stringify({
        loginID: agentId
      });
      
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
      };

      const res = await fetch(
        // `https://apitranxt.bumppypay.com//recApiFinal/apiget.aspx?method=getkycstatus&userid=${agentId}`,
        `${BASE_URL_API}/api/Apitranxt/getkycstatus`,
        requestOptions
      );

      const data = await res.json();
      setState({
        ...state,
        pipe1_kyc: data.f_ekyc_status == "COMPLETE" ? "COMPLETE" : "N",
      });

      setEkycStatus(data.f_ekyc_status == "COMPLETE" ? "COMPLETE" : "N");
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    twoFactorCheck();
    getkycstatus();
  }, []);

  console.log(state);


  return (
    <div style={{ padding: "1rem" }} className="bg-light">
      <div
        style={{ borderRadius: "8px" }}
        className="card m-0 p-0 mt-4 mr-2 ml-2 shadow-sm"
      >
        <div className="card-body m-3 p-1 px-2">
          <h4 className="mb-3">
            <b>AEPS KYC Status</b>
          </h4>

          <div className="d-flex justify-content-between align-items-center mb-3">
            <span>
              <b>E-KYC Status</b>
            </span>
            <span
              style={{
                backgroundColor:
                  ekycStatus === "COMPLETE" ? "#d4edda" : "#f8d7da",
                color: ekycStatus === "COMPLETE" ? "#155724" : "#721c24",
                padding: "5px 12px",
                borderRadius: "20px",
                fontSize: "0.85rem",
                fontWeight: "600",
                boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
              }}
            >
              {ekycStatus === "COMPLETE" ? "✅ Verified" : "⚠️ Pending"}
            </span>
          </div>

          <div className="d-flex justify-content-between align-items-center">
            <span>
              <b>Daily 2-Factor Status</b>
            </span>
            <span
              style={{
                backgroundColor:
                  ekycStatus === "Y" ? "#d4edda" : "#f8d7da",
                color: ekycStatus === "Y" ? "#155724" : "#721c24",
                padding: "5px 12px",
                borderRadius: "20px",
                fontSize: "0.85rem",
                fontWeight: "600",
                boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
              }}
            >
              {twoFactorStatus === "Y"
                ? "✅ Done"
                : "⚠️ Not Done"}
            </span>
          </div>

        </div>
      </div>
    </div>
  );
};
const Aeps2 = ({ agentId }) => {
  const initialState = {
    eKYCStatus: "",
    dailyFactorStatus: "",
  };

  const [state, setState] = useState(initialState);
  const [userRoles, setUserRoles] = useState([]);
  const [parentList, setParentList] = useState([]);

  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [activeTab, setActiveTab] = useState(0);

  const getKycAndTwoFactorStatus = async () => {
    try {
      setTransactionLoaderState(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userid: agentId,
        pipe: "INSTAPAY",
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.getKycAndTwoFactorStatus}`,
        requestOptions
      );

      const data = await res.json();
      if (data.responseCode === "00") {
        setState({
          eKYCStatus: data.data.kycStatus,
          dailyFactorStatus: data.data.twoFactorStatus,
        });
      } else {
        swal("Failed", data.responseMessage, "error");
      }
    } catch (error) {
      console.log("error", error);
      swal("Latitude Longitude Update Failed", "Error From Server", "error");
    } finally {
      setTransactionLoaderState(false);
    }
  };

  useEffect(() => {
    getKycAndTwoFactorStatus();
  }, []);

  return (
    <div style={{ padding: "1rem" }} className="bg-light">
      <div
        style={{ borderRadius: "8px" }}
        className="card m-0 p-0 mt-4 mr-2 ml-2 shadow-sm"
      >
        <div className="card-body m-3 p-1 px-2">
          <h4 className="mb-3">
            <b>AEPS 2 KYC Status</b>
          </h4>

          <div className="d-flex justify-content-between align-items-center mb-3">
            <span>
              <b>E-KYC Status</b>
            </span>
            <span
              style={{
                backgroundColor:
                  state.eKYCStatus === "Y" ? "#d4edda" : "#f8d7da",
                color: state.eKYCStatus === "Y" ? "#155724" : "#721c24",
                padding: "5px 12px",
                borderRadius: "20px",
                fontSize: "0.85rem",
                fontWeight: "600",
                boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
              }}
            >
              {state.eKYCStatus === "Y" ? "✅ Verified" : "⚠️ Pending"}
            </span>
          </div>

          <div className="d-flex justify-content-between align-items-center">
            <span>
              <b>Daily 2-Factor Status</b>
            </span>
            <span
              style={{
                backgroundColor:
                  state.dailyFactorStatus === "Verified"
                    ? "#d4edda"
                    : "#f8d7da",
                color:
                  state.dailyFactorStatus === "Verified"
                    ? "#155724"
                    : "#721c24",
                padding: "5px 12px",
                borderRadius: "20px",
                fontSize: "0.85rem",
                fontWeight: "600",
                boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
              }}
            >
              {state.dailyFactorStatus === "Y"
                ? "✅ Done"
                : "⚠️ Not Done"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AepsOnboarding;